class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.endDate = new Date(this.dataset.endDate).getTime();
    this.beforePanel = this.querySelector('[data-countdown-before]');
    this.afterPanel = this.querySelector('[data-countdown-after]');
    this.els = {
      days: this.querySelector('[data-days]'),
      hours: this.querySelector('[data-hours]'),
      minutes: this.querySelector('[data-minutes]'),
      seconds: this.querySelector('[data-seconds]'),
    };

    if (isNaN(this.endDate)) return;
    if (this.endDate <= Date.now()) return;

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  tick() {
    const remaining = this.endDate - Date.now();

    if (remaining <= 0) {
      this.showExpired();
      return;
    }

    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);

    this.setValue('days', days);
    this.setValue('hours', hours);
    this.setValue('minutes', minutes);
    this.setValue('seconds', seconds);
  }

  setValue(key, value) {
    if (this.els[key]) this.els[key].textContent = String(value).padStart(2, '0');
  }

  showExpired() {
    clearInterval(this.interval);
    if (this.beforePanel) this.beforePanel.hidden = true;
    if (this.afterPanel) this.afterPanel.hidden = false;
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define('countdown-timer', CountdownTimer);
